var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 11.5791,
    cy: 6.77803,
    r: 4.77803,
    stroke: "#979592",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.00002 18.2014C3.99873 17.8655 4.07385 17.5337 4.2197 17.2311C4.67736 16.3158 5.96798 15.8307 7.03892 15.611C7.81128 15.4462 8.59431 15.336 9.38217 15.2815C10.8408 15.1533 12.3079 15.1533 13.7666 15.2815C14.5544 15.3367 15.3374 15.4468 16.1099 15.611C17.1808 15.8307 18.4714 16.27 18.9291 17.2311C19.2224 17.8479 19.2224 18.564 18.9291 19.1808C18.4714 20.1419 17.1808 20.5812 16.1099 20.7918C15.3384 20.9634 14.5551 21.0766 13.7666 21.1304C12.5794 21.2311 11.3866 21.2494 10.1968 21.1854C9.92221 21.1854 9.65677 21.1854 9.38217 21.1304C8.59663 21.0773 7.81632 20.9641 7.04807 20.7918C5.96798 20.5812 4.68652 20.1419 4.2197 19.1808C4.0746 18.8747 3.99955 18.5401 4.00002 18.2014Z",
    stroke: "#979592",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserIcon);
export default __webpack_public_path__ + "static/media/userIcon.41e7b5f3951e332e6e75643649bdb484.svg";
export { ForwardRef as ReactComponent };